const path = "Polls";
export const SET_POLL = `${path}/SET_POLL`;
export const LIST_POLLS = `${path}/LIST_POLLS`;
export const SET_ENTRIES = `${path}/SET_ENTRIES`;
export const SET_RESULT_COUNT = `${path}/SET_RESULT_COUNT`;
export const SET_FILTER_TOTAL = `${path}/SET_FILTER_TOTAL`;
export const SET_CURRENT_PAGE = `${path}/SET_CURRENT_PAGE`;
export const SET_SEARCH_QUERY = `${path}/setSearchQuery`; // lower case for backwards compat
